var _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTag = function SvgTag(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -2.92514e-06 15.001 -2.56302e-06C6.7167 -2.2009e-06 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 30.001C23.2852 30.001 30.001 23.2852 30.001 15.001C30.001 6.71671 23.2852 0.000976563 15.001 0.000976563C6.71671 0.000976563 0.000976562 6.71671 0.000976562 15.001C0.000976562 23.2852 6.71671 30.001 15.001 30.001Z",
    fill: "url(#paint0_radial_1839_133325)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -1.01779e-06 15.001 -6.55671e-07C6.7167 -2.93554e-07 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "url(#paint1_linear_1839_133325)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -1.01779e-06 15.001 -6.55671e-07C6.7167 -2.93554e-07 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "url(#paint2_radial_1839_133325)",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3611 15.2014L14.7986 7.63894C14.67 7.51037 14.4947 7.4375 14.3125 7.4375H8.125C7.7455 7.4375 7.4375 7.7455 7.4375 8.125V14.3125C7.4375 14.4947 7.50969 14.67 7.63894 14.7986L10.1875 17.3471V20.5C10.1875 20.8795 10.4955 21.1875 10.875 21.1875C11.2545 21.1875 11.5625 20.8795 11.5625 20.5V12.9375C10.8028 12.9375 10.1875 12.3222 10.1875 11.5625C10.1875 10.8028 10.8028 10.1875 11.5625 10.1875C12.3215 10.1875 12.9375 10.8028 12.9375 11.5625V20.0971L15.2014 22.3611C15.3355 22.4958 15.5115 22.5625 15.6875 22.5625C15.8635 22.5625 16.0395 22.4951 16.1736 22.3611L22.3611 16.1736C22.6299 15.9054 22.6299 15.4703 22.3611 15.2014Z",
    fill: "#001947"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1839_133325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62503 22.5C12.3591 22.5 20.25 14.609 20.25 4.87501C20.25 3.46327 20.0841 2.0903 19.7705 0.774536C25.7161 2.76752 30 8.38349 30 15C30 23.2843 23.2843 30 15 30C9.44343 30 4.59251 26.9787 2.00049 22.4892C2.20778 22.4964 2.41598 22.5 2.62503 22.5Z",
    fill: "url(#paint3_linear_1839_133325)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1839_133325",
    x: 0.667155,
    y: -0.558797,
    width: 30.6662,
    height: 31.8921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1839_133325"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1839_133325",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1839_133325",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9456 -4.75482e-05) rotate(135) scale(26.2404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1839_133325",
    x1: 13.751,
    y1: -2.5,
    x2: 0.000974612,
    y2: 17.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1839_133325",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5002 7.125) rotate(143.291) scale(35.5496 29.3442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1839_133325",
    x1: 16.0041,
    y1: 30,
    x2: 19.7477,
    y2: 8.84735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag.0a75cf86.svg";
export { ForwardRef as ReactComponent };